module.exports = __webpack_public_path__ + "assets/AirbnbCereal-Medium.92fde700e65c5f78695221ed2c4d95cf.woff";